// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Quotes_quotes__CQc\\+w {
    display: flex;
    flex-direction: column;
    gap: 32px;
    background: var(--color-neutral-100);
    padding: 16px 0;
    border: 1px solid var(--color-neutral-800);
    border-radius: var(--radius-global);
    -webkit-border-radius: var(--radius-global);
    -moz-border-radius: var(--radius-global);
    -ms-border-radius: var(--radius-global);
    -o-border-radius: var(--radius-global);
    overflow: hidden;
}

.Quotes_quotesFilter__TlRwL {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: 16px;
    padding: 0 16px;
}

.Quotes_quotesFilter__TlRwL>div {
    width: 100%;
    max-width: 300px;
}

.Quotes_quotesTab__kb1Oz {
    display: flex;
    overflow: auto;
    justify-content: space-between;
    background: var(--color-neutral-200);
    padding: 0 16px;
    gap: 24px;
}

.Quotes_quotesTab__kb1Oz>button {
    display: flex;
    align-items: center;
    gap: 24px;
    padding: 16px 0;
    flex-shrink: 0;

}

.Quotes_quotesTab__kb1Oz>button.Quotes_active__ztXRS {
    border-bottom: solid 4px var(--color-primary);
}

.Quotes_quotesTab__kb1Oz>button>div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    color: var(--color-white);
    background: var(--color-neutral-500);
    border-radius: var(--radius-circle);
    -webkit-border-radius: var(--radius-circle);
    -moz-border-radius: var(--radius-circle);
    -ms-border-radius: var(--radius-circle);
    -o-border-radius: var(--radius-circle);
}

.Quotes_quotesQuickAccess__livkg {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0 16px;

}

.Quotes_quotesQuickAccess__livkg>button,.Quotes_quotesQuickAccess__livkg>a {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    background: var(--color-neutral-200);
    color: black;
    padding: 6px 16px;
    border: 1px solid var(--color-neutral-800);
    border-radius: var(--radius-global);
    -webkit-border-radius: var(--radius-global);
    -moz-border-radius: var(--radius-global);
    -ms-border-radius: var(--radius-global);
    -o-border-radius: var(--radius-global);
}

.Quotes_quotesQuickAccess__livkg>button:nth-child(1) {
    justify-content: flex-start !important;
}

.Quotes_quotesBody__\\+KGsY {
    display: flex;
    flex-direction: column;
    gap: 40px;
    padding: 0 16px;

}

.Quotes_quotesItem__9vvkL {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
}

.Quotes_quotesItem__9vvkL>button {
    display: flex;
    align-items: center;
    gap: 8px;
}

.Quotes_quotesItemBody__lYmpW {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    width: 100%;
    padding: 24px;
    border: 1px solid var(--color-neutral-800);
    border-radius: var(--radius-global);
    -webkit-border-radius: var(--radius-global);
    -moz-border-radius: var(--radius-global);
    -ms-border-radius: var(--radius-global);
    -o-border-radius: var(--radius-global);
}

.Quotes_quotesItemImg__Nv93W {
    width: 100%;
    border: 1px solid var(--color-neutral-800);
    border-radius: var(--radius-global);
    -webkit-border-radius: var(--radius-global);
    -moz-border-radius: var(--radius-global);
    -ms-border-radius: var(--radius-global);
    -o-border-radius: var(--radius-global);
    overflow: hidden;
}

.Quotes_quotesItemImg__Nv93W > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.Quotes_quotesItemInfo__TxS9T {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 24px;
}

.Quotes_quotesItemInfo__TxS9T>div {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.Quotes_quotesItemInfo__TxS9T>div>button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    background: var(--color-neutral-200);
    padding: 6px 16px;
    border-radius: var(--radius-global);
    -webkit-border-radius: var(--radius-global);
    -moz-border-radius: var(--radius-global);
    -ms-border-radius: var(--radius-global);
    -o-border-radius: var(--radius-global);
}

.Quotes_quotesItemInfo__TxS9T>div>button.Quotes_success__shVKx {
    background: rgba(12, 188, 139, 0.38);
    pointer-events: none;
}

.Quotes_quotesItemInfo__TxS9T>div>button.Quotes_warning__CXUUF {
    background: #E98862;
    color: var(--color-white);
    pointer-events: none;
}

.Quotes_quotesItemInfo__TxS9T>div>button.Quotes_warning_item__GUAqq {
    background: #E98862;
    color: var(--color-white);
    display: flex;
    justify-content: center;

}

.Quotes_quotesAttribute__NhBVG {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 24px;
}

.Quotes_quotesAttribute__NhBVG>div:nth-child(1) {
    width: 100%;
    max-width: 260px;
    text-align: center;
    font-weight: bold;
    background: #C1D8ED;
    ;
    padding: 6px 16px;
    border-radius: var(--radius-global);
    -webkit-border-radius: var(--radius-global);
    -moz-border-radius: var(--radius-global);
    -ms-border-radius: var(--radius-global);
    -o-border-radius: var(--radius-global);
}

.Quotes_quotesAttribute__NhBVG>div>p {
    max-width: 500px;
    display: flex;
    gap: 8px;
    color: var(--color-primary);
    font-size: .9rem;
}

.Quotes_quotesAttributeOffline__M0oOV {
    color: #E98862 !important;
}

.Quotes_quotesAttribute__NhBVG>div:nth-child(3) {
    display: flex;
    gap: 16px;
}


@media screen and (min-width :768px) {
    .Quotes_quotesFilter__TlRwL {
        display: flex;
        align-items: center;
        flex-direction: row;
    }

    .Quotes_quotesQuickAccess__livkg {
        flex-direction: row;
    }
    .Quotes_quotesItemInfo__TxS9T>div {
        width: 30%;}
}

@media screen and (min-width : 1200px) {
    .Quotes_quotesItemImg__Nv93W {
        width: 30%;
    }

    .Quotes_quotesItemInfo__TxS9T {
        width: calc(70% - 24px);
    }

}



/* #region priceModal */
.Quotes_priceModal__Xi4Up {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.Quotes_priceModalHeader__bhnGe {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.Quotes_priceModalHeader__bhnGe>div:nth-child(1) {
    width: 100%;
}

.Quotes_priceModalHeader__bhnGe>div:nth-child(2) {
    width: 30%;
    border: solid 1px var(--color-neutral-900);
    border-radius: var(--radius-global);
    overflow: hidden;
    display: none;
}

.Quotes_priceModalHeader__bhnGe>div:nth-child(2) img {
    width: 100%;
}

.Quotes_priceModalTab__gvwrX {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
}

.Quotes_priceModalTab__gvwrX>div {
    display: flex;
    flex-wrap: wrap;
}

.Quotes_priceModalTab__gvwrX>div>button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    gap: 16px;
    border: solid 1px var(--color-neutral-900);
    padding: 4px 16px;
}

@media screen and (min-width : 768px) {
    .Quotes_priceModalHeader__bhnGe>div:nth-child(1) {
        width: 65%;
    }

    .Quotes_priceModalHeader__bhnGe>div:nth-child(2) {
        display: block;
    }

    .Quotes_priceModalTab__gvwrX {
        flex-direction: row;
        align-items: center;
    }

    .Quotes_priceModalTab__gvwrX>div>button {
        width: -moz-fit-content;
        width: fit-content;
    }
}

.Quotes_priceModalTable__MjrCR {
    width: 100%;
    height: 100%;
    max-height: 260px;
    overflow: auto;
}

.Quotes_priceModalTable__MjrCR table,
.Quotes_priceModalTable__MjrCR th,
.Quotes_priceModalTable__MjrCR td {
    border: 1px solid black !important;
    border-collapse: collapse !important;
    text-align: center !important;
    padding: 4px !important;
}

.Quotes_priceModalTable__MjrCR tbody tr {
    cursor: pointer;
}

.Quotes_priceModalTable__MjrCR tfoot tr:nth-child(2) {
    cursor: pointer;
}

.Quotes_priceModalTable__MjrCR tbody tr:hover {
    background-color: var(--color-neutral-200);
}

.Quotes_priceModalTable__MjrCR table input {
    max-width: 80px !important;
    text-align: center !important;
}


.Quotes_orderInformationBtn__f702q {
    display: flex;
    justify-content: space-between;
}

.Quotes_orderInformationBtn__f702q>button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 8px;
    font-size: 1rem;
    background-color: var(--color-primary);
    color: var(--color-white);
    border-radius: var(--radius-global);
    gap: 4px;
    margin-top: 16px;
}

.Quotes_orderInformationBtn__f702q>button:nth-child(1) {
    width: calc(60% - 12px);
}

.Quotes_orderInformationBtn__f702q>button:nth-child(2) {
    width: calc(40% - 12px);
}

.Quotes_activePlanTableRow__b41U4 {
    background-color: var(--color-blue) !important;
}
/* #endregion priceModal */`, "",{"version":3,"sources":["webpack://./src/Styles/Quotes.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,oCAAoC;IACpC,eAAe;IACf,0CAA0C;IAC1C,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,8BAA8B;IAC9B,oCAAoC;IACpC,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,cAAc;;AAElB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,oCAAoC;IACpC,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;;AAEnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,oCAAoC;IACpC,YAAY;IACZ,iBAAiB;IACjB,0CAA0C;IAC1C,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;;AAEnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,WAAW;IACX,aAAa;IACb,0CAA0C;IAC1C,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,0CAA0C;IAC1C,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,oCAAoC;IACpC,iBAAiB;IACjB,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;AAC1C;;AAEA;IACI,oCAAoC;IACpC,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;;AAE3B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;;IAEnB,iBAAiB;IACjB,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;;AAGA;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;IACA;QACI,UAAU,CAAC;AACnB;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,uBAAuB;IAC3B;;AAEJ;;;;AAIA,uBAAuB;AACvB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,0CAA0C;IAC1C,mCAAmC;IACnC,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,0CAA0C;IAC1C,iBAAiB;AACrB;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,uBAAkB;QAAlB,kBAAkB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;;IAGI,kCAAkC;IAClC,oCAAoC;IACpC,6BAA6B;IAC7B,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;;AAGA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sCAAsC;IACtC,yBAAyB;IACzB,mCAAmC;IACnC,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8CAA8C;AAClD;AACA,0BAA0B","sourcesContent":[".quotes {\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n    background: var(--color-neutral-100);\n    padding: 16px 0;\n    border: 1px solid var(--color-neutral-800);\n    border-radius: var(--radius-global);\n    -webkit-border-radius: var(--radius-global);\n    -moz-border-radius: var(--radius-global);\n    -ms-border-radius: var(--radius-global);\n    -o-border-radius: var(--radius-global);\n    overflow: hidden;\n}\n\n.quotesFilter {\n    display: flex;\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 16px;\n    padding: 0 16px;\n}\n\n.quotesFilter>div {\n    width: 100%;\n    max-width: 300px;\n}\n\n.quotesTab {\n    display: flex;\n    overflow: auto;\n    justify-content: space-between;\n    background: var(--color-neutral-200);\n    padding: 0 16px;\n    gap: 24px;\n}\n\n.quotesTab>button {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    padding: 16px 0;\n    flex-shrink: 0;\n\n}\n\n.quotesTab>button.active {\n    border-bottom: solid 4px var(--color-primary);\n}\n\n.quotesTab>button>div {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    color: var(--color-white);\n    background: var(--color-neutral-500);\n    border-radius: var(--radius-circle);\n    -webkit-border-radius: var(--radius-circle);\n    -moz-border-radius: var(--radius-circle);\n    -ms-border-radius: var(--radius-circle);\n    -o-border-radius: var(--radius-circle);\n}\n\n.quotesQuickAccess {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding: 0 16px;\n\n}\n\n.quotesQuickAccess>button,.quotesQuickAccess>a {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    background: var(--color-neutral-200);\n    color: black;\n    padding: 6px 16px;\n    border: 1px solid var(--color-neutral-800);\n    border-radius: var(--radius-global);\n    -webkit-border-radius: var(--radius-global);\n    -moz-border-radius: var(--radius-global);\n    -ms-border-radius: var(--radius-global);\n    -o-border-radius: var(--radius-global);\n}\n\n.quotesQuickAccess>button:nth-child(1) {\n    justify-content: flex-start !important;\n}\n\n.quotesBody {\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    padding: 0 16px;\n\n}\n\n.quotesItem {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 24px;\n}\n\n.quotesItem>button {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.quotesItemBody {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 24px;\n    width: 100%;\n    padding: 24px;\n    border: 1px solid var(--color-neutral-800);\n    border-radius: var(--radius-global);\n    -webkit-border-radius: var(--radius-global);\n    -moz-border-radius: var(--radius-global);\n    -ms-border-radius: var(--radius-global);\n    -o-border-radius: var(--radius-global);\n}\n\n.quotesItemImg {\n    width: 100%;\n    border: 1px solid var(--color-neutral-800);\n    border-radius: var(--radius-global);\n    -webkit-border-radius: var(--radius-global);\n    -moz-border-radius: var(--radius-global);\n    -ms-border-radius: var(--radius-global);\n    -o-border-radius: var(--radius-global);\n    overflow: hidden;\n}\n\n.quotesItemImg > img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.quotesItemInfo {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 24px;\n}\n\n.quotesItemInfo>div {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.quotesItemInfo>div>button {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    background: var(--color-neutral-200);\n    padding: 6px 16px;\n    border-radius: var(--radius-global);\n    -webkit-border-radius: var(--radius-global);\n    -moz-border-radius: var(--radius-global);\n    -ms-border-radius: var(--radius-global);\n    -o-border-radius: var(--radius-global);\n}\n\n.quotesItemInfo>div>button.success {\n    background: rgba(12, 188, 139, 0.38);\n    pointer-events: none;\n}\n\n.quotesItemInfo>div>button.warning {\n    background: #E98862;\n    color: var(--color-white);\n    pointer-events: none;\n}\n\n.quotesItemInfo>div>button.warning_item {\n    background: #E98862;\n    color: var(--color-white);\n    display: flex;\n    justify-content: center;\n\n}\n\n.quotesAttribute {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 24px;\n}\n\n.quotesAttribute>div:nth-child(1) {\n    width: 100%;\n    max-width: 260px;\n    text-align: center;\n    font-weight: bold;\n    background: #C1D8ED;\n    ;\n    padding: 6px 16px;\n    border-radius: var(--radius-global);\n    -webkit-border-radius: var(--radius-global);\n    -moz-border-radius: var(--radius-global);\n    -ms-border-radius: var(--radius-global);\n    -o-border-radius: var(--radius-global);\n}\n\n.quotesAttribute>div>p {\n    max-width: 500px;\n    display: flex;\n    gap: 8px;\n    color: var(--color-primary);\n    font-size: .9rem;\n}\n\n.quotesAttributeOffline {\n    color: #E98862 !important;\n}\n\n.quotesAttribute>div:nth-child(3) {\n    display: flex;\n    gap: 16px;\n}\n\n\n@media screen and (min-width :768px) {\n    .quotesFilter {\n        display: flex;\n        align-items: center;\n        flex-direction: row;\n    }\n\n    .quotesQuickAccess {\n        flex-direction: row;\n    }\n    .quotesItemInfo>div {\n        width: 30%;}\n}\n\n@media screen and (min-width : 1200px) {\n    .quotesItemImg {\n        width: 30%;\n    }\n\n    .quotesItemInfo {\n        width: calc(70% - 24px);\n    }\n\n}\n\n\n\n/* #region priceModal */\n.priceModal {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.priceModalHeader {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n\n.priceModalHeader>div:nth-child(1) {\n    width: 100%;\n}\n\n.priceModalHeader>div:nth-child(2) {\n    width: 30%;\n    border: solid 1px var(--color-neutral-900);\n    border-radius: var(--radius-global);\n    overflow: hidden;\n    display: none;\n}\n\n.priceModalHeader>div:nth-child(2) img {\n    width: 100%;\n}\n\n.priceModalTab {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n.priceModalTab>div {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.priceModalTab>div>button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 50%;\n    gap: 16px;\n    border: solid 1px var(--color-neutral-900);\n    padding: 4px 16px;\n}\n\n@media screen and (min-width : 768px) {\n    .priceModalHeader>div:nth-child(1) {\n        width: 65%;\n    }\n\n    .priceModalHeader>div:nth-child(2) {\n        display: block;\n    }\n\n    .priceModalTab {\n        flex-direction: row;\n        align-items: center;\n    }\n\n    .priceModalTab>div>button {\n        width: fit-content;\n    }\n}\n\n.priceModalTable {\n    width: 100%;\n    height: 100%;\n    max-height: 260px;\n    overflow: auto;\n}\n\n.priceModalTable table,\n.priceModalTable th,\n.priceModalTable td {\n    border: 1px solid black !important;\n    border-collapse: collapse !important;\n    text-align: center !important;\n    padding: 4px !important;\n}\n\n.priceModalTable tbody tr {\n    cursor: pointer;\n}\n\n.priceModalTable tfoot tr:nth-child(2) {\n    cursor: pointer;\n}\n\n.priceModalTable tbody tr:hover {\n    background-color: var(--color-neutral-200);\n}\n\n.priceModalTable table input {\n    max-width: 80px !important;\n    text-align: center !important;\n}\n\n\n.orderInformationBtn {\n    display: flex;\n    justify-content: space-between;\n}\n\n.orderInformationBtn>button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    padding: 8px;\n    font-size: 1rem;\n    background-color: var(--color-primary);\n    color: var(--color-white);\n    border-radius: var(--radius-global);\n    gap: 4px;\n    margin-top: 16px;\n}\n\n.orderInformationBtn>button:nth-child(1) {\n    width: calc(60% - 12px);\n}\n\n.orderInformationBtn>button:nth-child(2) {\n    width: calc(40% - 12px);\n}\n\n.activePlanTableRow {\n    background-color: var(--color-blue) !important;\n}\n/* #endregion priceModal */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"quotes": `Quotes_quotes__CQc+w`,
	"quotesFilter": `Quotes_quotesFilter__TlRwL`,
	"quotesTab": `Quotes_quotesTab__kb1Oz`,
	"active": `Quotes_active__ztXRS`,
	"quotesQuickAccess": `Quotes_quotesQuickAccess__livkg`,
	"quotesBody": `Quotes_quotesBody__+KGsY`,
	"quotesItem": `Quotes_quotesItem__9vvkL`,
	"quotesItemBody": `Quotes_quotesItemBody__lYmpW`,
	"quotesItemImg": `Quotes_quotesItemImg__Nv93W`,
	"quotesItemInfo": `Quotes_quotesItemInfo__TxS9T`,
	"success": `Quotes_success__shVKx`,
	"warning": `Quotes_warning__CXUUF`,
	"warning_item": `Quotes_warning_item__GUAqq`,
	"quotesAttribute": `Quotes_quotesAttribute__NhBVG`,
	"quotesAttributeOffline": `Quotes_quotesAttributeOffline__M0oOV`,
	"priceModal": `Quotes_priceModal__Xi4Up`,
	"priceModalHeader": `Quotes_priceModalHeader__bhnGe`,
	"priceModalTab": `Quotes_priceModalTab__gvwrX`,
	"priceModalTable": `Quotes_priceModalTable__MjrCR`,
	"orderInformationBtn": `Quotes_orderInformationBtn__f702q`,
	"activePlanTableRow": `Quotes_activePlanTableRow__b41U4`
};
export default ___CSS_LOADER_EXPORT___;
